import InternalLink from "./InternalLink";
export default InternalLink;
